import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, Typography, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import history from '../../history';

const useStyles = makeStyles(theme => ({
    dialogActions: {
		justifyContent: 'center',
	},
	dialogButton: {
		minWidth: '100px',
	},
	dialogContent: {
		paddingBottom: '20px',
	},
	mainDialog: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
		textAlign: 'center',
	},
}));


const DiscardDialog = props => {
  const { open, onClose, link} = props;

  const classes = useStyles();

  return (

      <Dialog
        open={open}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="confirmation-dialog-title"
        fullWidth={true}
        maxWidth="sm"
        classes={{
            paper: classes.mainDialog,
        }}
        >
            <DialogContent classes={{ root: classes.dialogContent}}> <Typography component="h5"
                variant="h5"> You have unsaved changes, are you sure you want to exit? </Typography></DialogContent>
            <DialogActions className={classes.dialogActions}>
                
                <Button onClick={() => { onClose(); history.push({pathname: link})}} color="primary" variant="contained" className={classes.dialogButton}>
                    Yes, Discard
                </Button>
                <Button autoFocus onClick={onClose} color="primary" variant="contained" className={classes.dialogButton}>
                    No, Keep Working
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DiscardDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    link: PropTypes.string.isRequired
};
  
DiscardDialog.defaultProps = {
    open: false,
    onClose: () => {},
    link: '',
};
  
export default DiscardDialog;